import { GraphQLClient } from 'graphql-request'
export { gql } from 'graphql-request'

export default new GraphQLClient('/graphql')
